import { CloudCommand } from "../types.js";

export const setConversationIsRead: CloudCommand = {
    action: "CONVERSATION/SET_IS_READ",
    commandName: "conversation.setConversationIsRead",
    buildPayload: ({ params }) => params,
};
